// Module
var code = "<span class=\"SettingsCard__editItemValue\" data-hook=\"view-email-value\"> {{User.user.email}} </span> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/settings/userAccount/viewEmail.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;